import React from 'react';

import useTrackingEvent from '@hpstellar/core/hooks/useTrackingEvent';
import withPageComponents from '../../../page/components/with-page-components';

const PDP_METRICS = [
    // "See complete specs" button
    {
        action: 'see-more',
        component: 'pdp/TechSpecs',
        metrics: {
            eventName: 'linkClick',
            params: {
                event: 'e_linkClick',
                linkPlacement: 'product',
                linkId: 'see-complete-specs'
            }
        }
    },
    // "See more features" button
    {
        action: 'pdp/Features',
        component: 'see-more',
        metrics: {
            eventName: 'linkClick',
            params: {
                event: 'e_linkClick',
                linkPlacement: 'product',
                linkId: 'see-more-features'
            }
        }
    }
]


const TrackingPDPMetrics = ({ trackCustomMetric }) => {
    useTrackingEvent(e => {
        let { action, component } = e || {};
        for(let metric of PDP_METRICS){
            if(metric && metric.action === action && metric.component === component && metric.metrics){
                let {eventName, params} = metric.metrics;
                trackCustomMetric(eventName, params);
            }
        }
    });
    return null;
}

export default withPageComponents(TrackingPDPMetrics);